/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_IntermediateInputs */

const en_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediate`)
};

const es_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio`)
};

const fr_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédiaire`)
};

const de_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittelstufe`)
};

const ja_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中級者向け`)
};

const zh_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中级`)
};

const ar_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوسط`)
};

const id_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menengah`)
};

const it_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio`)
};

const ru_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Средний`)
};

const pt_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediário`)
};

const ko_val_intermediate = /** @type {(inputs: Val_IntermediateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중급`)
};

/**
* | output |
* | --- |
* | "Intermediate" |
*
* @param {Val_IntermediateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_intermediate = /** @type {((inputs?: Val_IntermediateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_IntermediateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_intermediate(inputs)
	if (locale === "es") return es_val_intermediate(inputs)
	if (locale === "fr") return fr_val_intermediate(inputs)
	if (locale === "de") return de_val_intermediate(inputs)
	if (locale === "ja") return ja_val_intermediate(inputs)
	if (locale === "zh") return zh_val_intermediate(inputs)
	if (locale === "ar") return ar_val_intermediate(inputs)
	if (locale === "id") return id_val_intermediate(inputs)
	if (locale === "it") return it_val_intermediate(inputs)
	if (locale === "ru") return ru_val_intermediate(inputs)
	if (locale === "pt") return pt_val_intermediate(inputs)
	return ko_val_intermediate(inputs)
});